export const stayPromotions = {
  title: "Promozioni sul soggiorno",
  description: "Offri sconti speciali ai tuoi ospiti per soggiorni più lunghi",
  newPromotion: "Nuova promozione",
  loading: "Caricamento delle promozioni...",
  close: "Chiudi",
  cancel: "Annulla",
  noLimit: "Nessun limite",

  status: {
    active: "Attiva",
    paused: "In pausa",
  },

  card: {
    stay: "Soggiorno",
    discount: "Sconto",
    validity: "Validità",
    edit: "Modifica",
    delete: "Elimina",
  },

  nights: {
    range: "{min} - {max} notti",
    min: "{min}+ notti",
  },

  empty: {
    title: "Nessuna promozione configurata",
    description: "Crea promozioni per incentivare soggiorni più lunghi e aumentare le tue prenotazioni",
    create: "Crea la prima promozione",
  },

  form: {
    editTitle: "Modifica promozione",
    createTitle: "Nuova promozione",
    nameLabel: "Nome della promozione",
    namePlaceholder: "es. sconto 7 notti, Offerta settimanale",
    minNights: "Notti minime",
    maxNights: "Notti massime",
    optional: "(facoltativo)",
    noLimitPlaceholder: "Nessun limite",
    discountType: "Tipo di sconto",
    percentage: "Percentuale",
    fixedAmount: "Importo fisso",
    discountValue: "Valore dello sconto",
    validFrom: "Valido dal",
    validTo: "Valido fino al",
    activateNow: "Attiva subito la promozione",
    saving: "Salvataggio...",
    update: "Aggiorna",
    create: "Crea promozione",
  },

  invoice: {
    title: "Esempio di risparmio",
    pricePerNight: "Prezzo per notte",
    numberOfNights: "Numero di notti",
    subtotal: "Subtotale",
    discountApplied: "Sconto applicato",
    totalToPay: "Totale da pagare",
    guestSaves: "L'ospite risparmia {amount}",
  },

  statusModal: {
    activateTitle: "Attiva promozione",
    pauseTitle: "Metti in pausa la promozione",
    activateDescription: 'Vuoi attivare la promozione "{name}" in modo che venga applicata alle nuove prenotazioni?',
    pauseDescription: 'Vuoi mettere in pausa la promozione "{name}"?',
    confirm: "Conferma",
  },

  deleteModal: {
    title: "Elimina promozione",
    warningStrong: "Questa azione non può essere annullata.",
    warningText: "Prima di eliminarla, assicurati di non aver più bisogno della promozione {name}.",
    confirmLabel: "Digita il nome esatto per confermare:",
    confirmPlaceholder: "Digita esattamente il nome della promozione",
    hint: "Incolla o digita il nome esattamente come appare sopra per abilitare il pulsante di eliminazione.",
    deleting: "Eliminazione...",
    confirmDelete: "Elimina definitivamente",
  },

  toasts: {
    nameRequired: "Inserisci un nome",
    minNightsWarning: "Le notti minime devono essere 1 o più",
    selectRatePlan: "Seleziona un piano tariffario base",
    updated: "Promozione aggiornata",
    created: "Promozione creata",
    saveFailed: "Impossibile salvare",
    saveError: "Errore durante il salvataggio",
    activated: "Promozione attivata",
    pausedToast: "Promozione messa in pausa",
    updateFailed: "Impossibile aggiornare",
    statusError: "Errore durante la modifica dello stato",
    deleted: "Promozione eliminata",
    deleteFailed: "Impossibile eliminare",
    deleteError: "Errore durante l'eliminazione",
  },
};
